
export const getColumnWidthsFromLocalStorage = (
  tableId?: string,
): Record<string, number> | undefined => {
  if (!tableId) return undefined;
  const columnWidthFromStorage = localStorage.getItem(`${tableId}-columnWidths`);
  if (columnWidthFromStorage) {
    try {
      return JSON.parse(columnWidthFromStorage);
    } catch (error) {
      console.error("Error parsing column width from localStorage:", error);
      localStorage.removeItem(`${tableId}-columnWidths`);
    }
  }
  return undefined;
};

export const saveColumnWidthToLocalStorage = (
  tableId?: string,
  field?: string,
  width?: number
):void => {
   if (!tableId || !width || !field ) return;
   const existing = getColumnWidthsFromLocalStorage(tableId);
   localStorage.setItem(
    `${tableId}-columnWidths`,
    JSON.stringify({...existing, [field]: width}) 
   );
}